export class PromoBanner {
  static init({ appleAppStoreLink, googlePlayStoreLink, otherLink, androidTrackEvent, iosTrackEvent, otherTrackEvent }) {
    const mobileTypes = {
      ANDROID: 'android',
      IOS: 'ios',
      OTHER: 'other',
    };
    
    const bannerLink = document.querySelector('.js-app-promo-banner-mobile');
    
    if (!bannerLink) {
      return;
    }

    const mobileType = PromoBanner.getMobileType(mobileTypes);
    const playStoreLink = bannerLink.querySelector(`.js-app-store-link--${mobileTypes.ANDROID}`);
    const appStoreLink = bannerLink.querySelector(`.js-app-store-link--${mobileTypes.IOS}`);

    if (mobileType === mobileTypes.OTHER && playStoreLink && appStoreLink) {
      bannerLink.href = otherLink;
      bannerLink.setAttribute('data-ya-track', otherTrackEvent);
      playStoreLink.classList.remove('is-hidden');
      appStoreLink.classList.remove('is-hidden');
    } else if (mobileType === mobileTypes.ANDROID && playStoreLink) {
      bannerLink.href = googlePlayStoreLink;
      bannerLink.setAttribute('data-ya-track', androidTrackEvent);
      playStoreLink.classList.remove('is-hidden');
    } else if (mobileType === mobileTypes.IOS && appStoreLink) {
      bannerLink.href = appleAppStoreLink;
      bannerLink.setAttribute('data-ya-track', iosTrackEvent);
      appStoreLink.classList.remove('is-hidden');
    }
  }

  static getMobileType(mobileTypes) {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      return mobileTypes.ANDROID;
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return mobileTypes.IOS;
    }

    return mobileTypes.OTHER;
  }
}